import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell,
    colors
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import EditAdmin from '../../EditAdmin/EditAdmin';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { delete_admin } from '../../../api/API';

const useStyles = makeStyles(theme => ({
    root: {},

    content: {
        padding: 0
    },

    actions: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        '& > * + *': {
            marginLeft: 0
        }
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    },

    editButton: {
        color: theme.palette.white,
        backgroundColor: colors.blue[600],
        '&:hover': {
            backgroundColor: colors.blue[900]
        }
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },

}));

export default class DetailData extends React.Component {

    constructor(props) {
        super(props);
        console.log('DetailData');
        console.log(props);
        this.state = {
            admins: props.admins,
            admin_id: props.admin_id,
            show_edit: false
        };
        this.user_id = window.localStorage.getItem("user_id");
    }

    componentWillReceiveProps(props) {
        this.setState({
            admins: props.admins
        });
    }

    // const {  className, ...rest } = props;
    // const admins = props.admins;
    // const classes = useStyles();

    // const [openEdit, setOpenEdit] = useState(false);

    handleEditOpen() {
        //setOpenEdit(true);
    };

    handleEditClose() {
        this.setState({
            ...this.state,
            show_edit: false
        });
        this.props.refresh();
    };

    async handleDelete() {
        if(window.confirm("Are you sure ?")){
            let data = await delete_admin(this.state.admin_id);
            if(data){
                this.props.history.push("/admin");
            }else{
                alert("Something went wrong");
            }
            
        }
    }
 
    render() {
        return (
            <Card

            >
                <CardHeader title="Admin Detail" action={(
                    <React.Fragment>
                        {window.localStorage.getItem("role") == 'superadmin' ?
                            <React.Fragment>
                                <Button variant="contained"
                                    onClick={() => {
                                        this.setState({
                                            ...this.state,
                                            show_edit: true
                                        });
                                    }}
                                >
                                    <EditIcon className={this.props.classes.leftIcon} />
                                Edit</Button>
                                {
                                    this.user_id != this.state.admin_id && (
                                        <Button variant="contained"
                                            style={{
                                                backgroundColor: "red",
                                                marginLeft: 10
                                            }}
                                            onClick={(() => {
                                                this.handleDelete();
                                            }).bind(this)}
                                        >
                                            <DeleteIcon className={this.props.classes.leftIcon} />
                                Delete</Button>
                                    )}
                            </React.Fragment>
                            : ''
                        }
                    </React.Fragment>
                )} />
                <Divider />
                <CardContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>
                                    {this.state.admins.name}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Email</TableCell>
                                <TableCell>{this.state.admins.email}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Contact Number</TableCell>
                                <TableCell>{this.state.admins.contact}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Position</TableCell>
                                <TableCell>{this.state.admins.role_id == '1' ? 'superadmin' : 'admin'}</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </CardContent>
                <CardActions className={this.props.classes.actions}>
                    {/* <Button className={this.props.classes.editButton} onClick={this.handleEditOpen}>
                            Edit
                        </Button> */}
                </CardActions>
                {
                    this.state.show_edit && (
                        <EditAdmin
                            admins={this.state.admins}
                            onClose={this.handleEditClose.bind(this)}
                            open={this.state.show_edit}
                        />)
                }
            </Card>
        );
    }
}
